import React from 'react';
import styles from 'routes/adminMobile/components/AdminMobileEachStoreBest.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import { mainBgColor, mainPadd2, pageEH2FontSize, pageEH3FontSize, registerGap2 } from '../constraints/AdminConst';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import backIcon from 'routes/vendorRe/images/back_icon.png';

const AdminMobileEachStoreBest = ({storeData}) => {
    

    // storeData가 존재하지 않는 경우에 대한 예외 처리
    if (!storeData) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    // 상품당 판매가, 총 구매수, 제품 개당 판매가, 이미지 경로를 저장할 배열
    let bestSellingProducts = [];

    // buyers와 products 배열을 순회하면서 상품당 판매가, 총 구매수, 제품 개당 판매가, 이미지 경로를 계산하여 객체로 만듦
    storeData.products.forEach(product => {
        const productSales = storeData.buyers.reduce((acc, buyer) => {
            const index = buyer.productNo.indexOf(product.productNo);
            if (index !== -1) {
                acc.totalSalesPrice += product.productSalesPrice * buyer.productCnt[index];
                acc.totalQuantity += buyer.productCnt[index];
            }
            return acc;
        }, { totalSalesPrice: 0, totalQuantity: 0 });

        const unitSalesPrice = productSales.totalQuantity > 0 ? productSales.totalSalesPrice / productSales.totalQuantity : 0;

        bestSellingProducts.push({
            productNo: product.productNo,
            productName: product.productName,
            totalSalesPrice: productSales.totalSalesPrice,
            totalQuantity: productSales.totalQuantity,
            unitSalesPrice: unitSalesPrice,
            productImg: product.productImg // 이미지 경로 추가
        });
    });

    // totalQuantity 기준으로 내림차순 정렬
    bestSellingProducts.sort((a, b) => b.totalQuantity - a.totalQuantity);
    

    return (
        <VerticalFlex backgroundColor={mainBgColor} padding={mainPadd2}>
            <FlexChild>
                <AdminMobileContentBox flexStart>
                    <VerticalFlex>
                        <FlexChild>
                            <div className={styles.borderBottom}>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <P size={pageEH2FontSize}>주간 판매량 BEST</P>
                                    </FlexChild>
                                    <FlexChild justifyContent="flex-end">
                                        <img className={styles.moveIcon} src={backIcon} alt='이동 아이콘' />
                                    </FlexChild>
                                </HorizontalFlex>
                            </div>
                        </FlexChild>
                        <FlexChild>
                            {/* 반복 구간 */}
                            {bestSellingProducts && bestSellingProducts.map((product, index) => (
                                <div key={index} className={styles.borderBottom2}>
                                    <HorizontalFlex gap={registerGap2}>
                                        <FlexChild justifyContent="center" width="auto">
                                            <img className={styles.productImg} src={product.productImg} alt='상품 이미지' />
                                        </FlexChild>
                                        <FlexChild>
                                            <VerticalFlex gap={registerGap2}>
                                                <FlexChild alignItems="flex-start">
                                                    <P size={pageEH3FontSize}>{product.productName}</P>
                                                </FlexChild>
                                                <FlexChild alignItems="flex-start">
                                                    <HorizontalFlex>
                                                        <FlexChild>
                                                            <P size={pageEH3FontSize}>
                                                                {product.unitSalesPrice ? product.unitSalesPrice.toLocaleString() : 0}
                                                            </P>
                                                        </FlexChild>
                                                    </HorizontalFlex>
                                                </FlexChild>
                                            </VerticalFlex>
                                        </FlexChild>
                                        <FlexChild width="auto">
                                            <P weight={700} size={pageEH3FontSize} padding="0px 1.5rem 0px 0px">
                                                {product.totalQuantity ? product.totalQuantity.toLocaleString() : 0}
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </div>
                            ))}
                            {/* 반복 구간 */}
                        </FlexChild>
                    </VerticalFlex>
                </AdminMobileContentBox>
            </FlexChild>
        </VerticalFlex>
    );
};

export default AdminMobileEachStoreBest;